import React from 'react';
import Dropzone from 'react-dropzone';
import { Icon, Button, List } from 'semantic-ui-react';

class FileUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            files: []
        };
    }

    onDrop(files) {
        this.setState({ files });
    }

    render() {
        return (
            <div>
                <Dropzone id="dropzonefiles" onDrop={this.onDrop.bind(this)} align="center">
                    <br />
                    <Button type="button" size="small" color="grey">
                        <Icon name="upload" /> UPLOAD FILE
                    </Button>
                </Dropzone>
                <List divided relaxed>
                    {
                        this.state.files.map(f =>
                            (<List.Item key={f.name}>
                                <List.Content> <Icon name="file outline" /> {f.name}</List.Content>
                             </List.Item>)
                        )
                    }
                </List>
            </div>
        );
    }
}

export default FileUpload;



// WEBPACK FOOTER //
// ./source/containers/Surveys/Sidebar/Documents/FileUpload.jsx